export const transitionTime = '400ms';
export const easeOutExpo = 'cubic-bezier(0.19, 1, 0.22, 1)';
